<template>
    <div>
        <topbar></topbar>
        <sidebar></sidebar>
        <router-view></router-view>
    </div>
</template>

<script>
import topbar from './components/topbar'
import sidebar from './components/sidebar'

export default {
    components:{
        topbar,
        sidebar
    }
}
</script>
